import { Types } from 'mongoose';
import {
    PAYMENT_STATUS_COMPLETED_ID,
    PAYMENT_STATUS_PENDING_ID,
    PAYMENT_STATUS_PENDING_LABEL,
} from './payment-type.const';

export const PAYMENT_STATUS = {
    type: 'Payment Status',
    category: 'System',
    value: [
        {label: PAYMENT_STATUS_PENDING_LABEL, _id: new Types.ObjectId(PAYMENT_STATUS_PENDING_ID)},
        {label: 'Completed', _id: new Types.ObjectId(PAYMENT_STATUS_COMPLETED_ID)},
        {label: 'Rejected', _id: new Types.ObjectId('507f1f77bcf86cd799439033')},
    ],
};

export const PAYMENT_TYPE = {
    type: 'Payment Type',
    category: 'System',
    value: [
        {
            label: 'Individual',
            _id: new Types.ObjectId('507f1f77bcf86cd799439035'),
            description: 'Payment made by an individual',
        },
        {
            label: 'Organization',
            _id: new Types.ObjectId('507f1f77bcf86cd799439034'),
            description: 'Payment made by organization',
        },
    ],
};

export const REDUCTION_TYPE = {
    type: 'Reduction Type',
    category: 'System',
    value: [
        {
            label: 'Scholarship',
            _id: new Types.ObjectId('507f1f77bcf86cd799439036'),
            description: 'CMC provides scholarship to user/participant',
        },
        {
            label: 'Grant Covered',
            _id: new Types.ObjectId('507f1f77bcf86cd799439037'),
            description: 'CMC waives or reduces fee for user/participant; uses grant funds to cover training costs',
        },
        {
            label: 'Work Trade',
            _id: new Types.ObjectId('507f1f77bcf86cd799439038'),
            description: 'CMC waives or reduces training fee in exchange for work by user/participant',
        },
        {
            label: 'Reduced Fee',
            _id: new Types.ObjectId('507f1f77bcf86cd799439039'),
            description: 'CMC reduces training fee for user/participant',
        },
        {
            label: 'Other', 
            _id: new Types.ObjectId('507f1f77bcf86cd799439040'), 
            description: 'CMC reduces training fee for Other reason',
        },
    ],
};
